import { Resources } from 'constants/resources';

import { ResourceProps } from 'react-admin';

import { ApiClientsCreate } from './ApiClientsCreate/ApiClientsCreate';
import { ApiClientsEdit } from './ApiClientsEdit/ApiClientsEdit';
import { ApiClientsList } from './ApiClientsList/ApiClientsList';
import { ApiClientsShow } from './ApiClientsShow/ApiClientsShow';

export const apiClientsResource: ResourceProps = {
  name: Resources.ApiClients,
  create: ApiClientsCreate,
  edit: ApiClientsEdit,
  list: ApiClientsList,
  show: ApiClientsShow,
};
